import { Input, Table, Tag, message, Checkbox } from 'antd';
import { useState } from 'react';
import { use1688DeliveriesList } from '../../api/1688-delivery/hooks';
import { CalledCheckbox } from './libs';
import {jwtDecode} from "jwt-decode";
import Cookies from "js-cookie";

const columns = [
    {
        title: 'Трек-код',
        dataIndex: 'trackCode',
        render: (trackCode) => (
            <a
                onClick={() => {
                    navigator.clipboard
                        .writeText(trackCode)
                        .then(() => message.success('Скопировано!'))
                        .catch(() => message.error('Ошибка при копировании'));
                }}
            >
                {trackCode}
            </a>
        ),
    },
    {
        title: 'Город',
        dataIndex: 'city',
    },
    {
        title: 'Филиал',
        dataIndex: 'filial',
    },
    {
        title: 'Номер телефона',
        dataIndex: 'customerPhone',
    },
    {
        title: 'Имя',
        dataIndex: 'customerName',
    },
    {
        title: 'Позвонили',
        dataIndex: 'isCalled',
        render: (_, data) => <CalledCheckbox data={data} />,
    },
];

const getCountry = () => {
    const token = Cookies.get('token');
    const country = jwtDecode(token).country;
    return country;
}

export function SixteenEightyEightDelivered() {
    const [currentPage, setCurrentPage] = useState(0);
    const [search, setSearchValue] = useState('');
    const { deliveries, isLoading } = use1688DeliveriesList(currentPage, search, getCountry());

    const onChange = (e) => {
        setSearchValue(e.target.value);
        setCurrentPage(0);
    };

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                padding: '0 40px',
            }}
        >
            <div style={{ marginBottom: '10px', fontSize: '48px' }}>
                <h3 style={{ fontWeight: '200' }}>Доставки для 1688</h3>
            </div>
            <div style={{ display: 'flex', gap: '20px' }}>
                <Input
                    placeholder="Введите трек-код"
                    size="middle"
                    style={{ marginBottom: '20px' }}
                    onChange={onChange}
                />
            </div>

            <Table
                key={currentPage}
                columns={columns}
                dataSource={deliveries.content || []}
                loading={isLoading}
                style={{ width: '100%' }}
                pagination={{
                    current: deliveries.number + 1,
                    pageSize: deliveries.size,
                    total: deliveries.totalElements,
                    onChange: (page) => {
                        setCurrentPage(page - 1);
                    },
                }}
            />
        </div>
    );
}
